import styled from 'styled-components'

export const HotContainer = styled.div`
    .handsontable {
        font-size: 13px;

        td {
            vertical-align: middle;
            background-color: var(--gray-0);
        }

        th {
            background-color: var(--gray-200);
            color: ${({ theme }) => theme['dark-icons']};
            border: none;
            border-right: 1px solid ${({ theme }) => theme['gray-darker-bg']};
            font-size: 10px;
            font-family: ${({ theme }) => theme['font-semibold']};
            letter-spacing: 1px;
            line-height: 25px;
            text-align: left;
            text-transform: uppercase;

            &:first-child {
                border-left: 1px solid ${({ theme }) => theme['gray-darker-bg']};
            }
        }

        th.ht__highlight {
            background-color: var(--gray-300) !important;
        }

        th,
        td {
            border-color: var(--gray-400) !important;
        }

        input {
            border-color: var(--gray-400) !important;
            background-color: var(--gray-0) !important;
        }

        .highlighted-row {
            > td {
                background-color: var(--blue-200);
            }
        }

        .handsontableInput {
            background-color: var(--gray-0);
            color: var(--gray-800);
        }

        .handsontable.listbox tr:hover td,
        .handsontable.listbox tr td.current {
            background-color: var(--gray-300);
        }

        .handsontableEditor.autocompleteEditor {
            box-shadow: ${({ theme }) => theme['gray-darker-bg']} 2px 4px 5px;
            padding-right: 0;
            width: calc(100% - 15px) !important;
            .ht_master {
                padding-right: 0 !important;
            }
            .ht_master .wtHolder {
                overflow-x: hidden !important;
            }
        }
        .ht_master .wtHolder {
            box-shadow: inset ${({ theme }) => theme['gray-darker-bg']} 0px 0px 0px 1px;
            width: calc(100%) !important;
        }
        .is-readOnly {
            background-color: var(--gray-lighter) !important;
        }
    }
`
